"use client";
import { useAppContext } from "@/providers/AppProvider";
import { ISkill } from "@/types";
import { Code } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useEffect, useRef } from "react";

function Skills() {
    const { skills } = useAppContext();
    const skillsRef = useRef<HTMLElement | null>(null);

    // Scrolling to section if url has hash
    useEffect(() => {
        const hash = window.location.hash;
        if (hash === "#skills") {
            if (skillsRef.current) {
                skillsRef.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }
    }, []);

    return (
        <section ref={skillsRef} id="skills" className="pt-8">
            <h1 className="mb-4 flex items-center gap-4 text-2xl font-bold lg:text-3xl">
                <Link href="#skills" className="flex items-center gap-4">
                    <Code className="size-10 text-primary" />
                    Skills
                </Link>
            </h1>
            <div className="flex flex-col gap-4">
                {skills?.map((group, index) => (
                    <div key={index}>
                        <h3 className="mb-2 py-4 text-lg font-semibold text-text-color md:text-xl">
                            {group.name}
                        </h3>
                        <SkillsCard skills={group.skills} />
                    </div>
                ))}
            </div>
        </section>
    );
}
export default Skills;

interface SkillsCardProps {
    skills: ISkill[];
}

export const SkillsCard = ({ skills }: SkillsCardProps) => {
    return (
        <div className="flex flex-wrap gap-4">
            {skills.map((skill, skillIndex) => (
                <div
                    key={skillIndex}
                    className="relative flex flex-row items-center gap-2 rounded-lg border border-border-color bg-card-bg px-3 py-2 transition-transform duration-300 hover:scale-105 hover:border-primary sm:w-[130px] sm:flex-col sm:gap-4 sm:p-4"
                >
                    <Image
                        src={skill.imageUrl}
                        alt={skill.name}
                        width={0}
                        height={0}
                        sizes="100vw"
                        className="h-8 w-8 object-contain sm:h-auto sm:w-full"
                        unoptimized={skill.imageUrl.endsWith(".svg")}
                    />
                    <p className="text-center text-lg font-medium text-text-color sm:text-sm">
                        {skill.name}
                    </p>
                </div>
            ))}
        </div>
    );
};
